const CREDIT_DISPLAY_SCALE = 1000;
const creditFormatter = new Intl.NumberFormat("en-US");

/**
 * Convert raw provider-token units into user-facing credit units.
 * Example: 250000 raw tokens -> 250 displayed credits.
 */
export const toDisplayCredits = (rawTokens) =>
  Math.max(0, Math.round(Number(rawTokens || 0) / CREDIT_DISPLAY_SCALE));

/**
 * Convert user-facing credit units into raw provider-token units.
 * Example: 250 displayed credits -> 250000 raw tokens.
 */
export const toRawTokens = (displayCredits) => {
  const parsed = Number(displayCredits);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return 0;
  }

  return Math.round(parsed * CREDIT_DISPLAY_SCALE);
};

export const formatDisplayCredits = (rawTokens) =>
  creditFormatter.format(toDisplayCredits(rawTokens));
